// extracted by mini-css-extract-plugin
module.exports = {"root":"participantSummary_root__TnboV","participant":"participantSummary_participant__B055m","representative":"participantSummary_representative__CaYvn"};